import { render, staticRenderFns } from "./compose.vue?vue&type=template&id=27eef082&scoped=true&"
import script from "./compose.vue?vue&type=script&lang=ts&"
export * from "./compose.vue?vue&type=script&lang=ts&"
import style0 from "./compose.vue?vue&type=style&index=0&id=27eef082&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eef082",
  null
  
)

export default component.exports